import 'materialize-css/js/cash';
import 'materialize-css/js/global';
import 'materialize-css/js/waves'

const Component = require('exports-loader?Component!materialize-css/js/component.js');
global.Component = Component;
